module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Chapter-Headers",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("150th Anniversary—"), _c('br'), _vm._v("Sisters of Notre Dame de Namur")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Background-Info"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("This homily was delivered in conjunction with a televised Mass in 1990 marking the 150th anniversary of the arrival of the Sisters of Notre Dame in the United States. Sister Mary Johnson, a contributor to this volume, was interviewed following the Mass. A link to a recording of this televised Mass is found in the appendix to this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Indent"
  }, [_c('span', {
    staticClass: "All-Cap-Lead-In CharOverride-5"
  }, [_vm._v("When people know")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" they have less than 24 hours to live, whatever they say or do is ")]), _c('span', {
    staticClass: "No-Break CharOverride-1"
  }, [_vm._v("important.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("If you had only 24 hours to live, what would you "), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("say or do?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("Today, we look at what Christ said and did on the day before he died. He took His closest friends, went to a special place, and celebrated the Last Supper. He spoke words and performed an act of timeless meaning. At that table, Jesus took bread, and He took the cup. He then said, “This is My body. This is My blood. Do this in remembran"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("ce of Me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("Ever since that day, the Eucharist has been celebrated in catacombs, in stately cathedrals, in monasteries, in ordinary parish churches, in hidden rooms in persecuted countries. Wherever in what circumstances it has been celebrated, the Eucharist has always been a sign of the sustaining, loving presence of"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v(" the Lord.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("The night before He died, Jesus not only celebrated the Eucharist. He also uttered important words as His last will and legacy of re"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("membrance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("Our gospel reading for today is part of that farewell address spoken by Jesus before his death. With deep love and care for His disciples and those who would come after them, He said, “I will never leave you alone. I will send you the Holy Spirit to be with yo"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("u always.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("The promised Spirit would come and, like Jesus, teach, lead, comfort, and strengthen. The Spirit would be a friend and guide. What a consoling and gracious gift those first disciples and we have in t"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("he Spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("In a special way today, we celebrate a particular manifestation of the saving work of the Spirit who continues to inspire the Church in "), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("every age.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v(" Come back with me 150 years to October 19, 1840, when eight Sisters of Notre Dame de Namur, a religious community founded by Saint Julie Billiart, arrived in the United States from Belgium. The Sisters settled in Ohio and ministered to the many needs of the immigrant Church there. In 1867, a small group came to Holy Name, Chicopee; in 1869, to Saint Jerome’s, Holyoke; and in 1877, to Sacred Heart, Springfield. They established the first Catholic schools in our Diocese in Chicopee, Holyoke, and Springfield. They planted the seeds of faith in the hearts and minds of thousands of young people in western Mass"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("achusetts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("The promise of Christ to send the Spirit was embodied generously and lovingly in the zeal, courage, and devotion of those first Sisters of Notre Dame. From the beginning, their work and mission embraced the poor and needy, especially the poor children in schools they founded throughout our country a"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("nd abroad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("In the Diocese of Springfield, hundreds of Sisters of Notre Dame have endeared themselves to grateful students and families for 120 years. Having lived at Sacred Heart for the past 17 years and having served with the Sisters of Notre Dame, I can personally speak of the great respect, love, and affection of the priests and people for these, ou"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("r Sisters.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("In recent years, the Sisters have embraced many other ministries besides teaching. Here, at Sacred Heart, they were instrumental in founding the Spanish Apostolate. Today, they are engaged in parish ministry and serve in health care"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v(" settings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("Although the Sisters of Notre Dame ask nothing of us, we owe them an immense debt of gratitude as we rejoice with them in this 150th anniver"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("sary year.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("Sisters, your work is not finished. The promise of the Spirit to teach, guide, comfort, and strengthen is enfleshed in your witness. With you, we cherish your proud past. We celebrate your creative ministerial dedication today. We join with you in hope and optimism as you meet the many opportunities and challenges of"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v(" tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("In that timeless moment long ago, when Jesus sat down at table with His disciples, He said that the Father would send us the Spirit to be with us always. He promised that his disciples of all ages would do even greater things than He. That promise sustains us and is embodied in the spirit-filled gifts of generous service which you, the Sisters of Notre Dame, consistently share with all God"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v("’s people.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Copy"
  }, [_vm._v("We pray today for and with all Sisters of Notre Dame who, in the spirit of Julie Billiart, remind us each day of the goodness of the"), _c('span', {
    staticClass: "No-Break"
  }, [_vm._v(" good God.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad25655","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlongTheWay_ebook-11.vue
// module id = 90
// module chunks = 0